import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FieldValues, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useTopUp } from '../../../../context/TopupContext';
import { UtilService } from '../../../../services';
import { TopUpNautaItem } from '../../../../types/topupItems';
import { MegaCarrier, MegaCarrierRate } from '../../../../types/topups';
import { TopupProducts, TopupProductsProps } from '../../topupProducts';
import { TopUpAddButton } from '../topupAddButton';

const NAUTA_SUFFIX = '@nauta.com.cu';

const nautaSchema = yup
  .object()
  .shape({
    nauta: yup
      .string()
      .required('El email Nauta es un campo requerido.')
      .test('email', 'Su email nauta no es válido.', (value) => {
        const schema = yup.string().email();
        return schema.isValidSync(`${value}${NAUTA_SUFFIX}`);
      }),
  })
  .required();

export const TopUpNautaEmail = ({
  carrier,
  carrierRates,
}: {
  carrier: MegaCarrier;
  carrierRates: MegaCarrierRate[];
}) => {
  const [selectedCarrierRate, setSelectedCarrierRate] = useState<MegaCarrierRate>();
  const [productList, setProductList] = useState<TopupProductsProps['products']>([]);

  const { register, handleSubmit, formState, reset, clearErrors } = useForm({
    resolver: yupResolver(nautaSchema),
    mode: 'onChange',
  });

  const { addNautaItem } = useTopUp();

  useEffect(() => {
    if (carrierRates.length > 0) {
      setSelectedCarrierRate(carrierRates[0]);
      convertProductList(carrierRates);
    }
  }, [carrierRates]);

  const isButtonDisabled = () => {
    return selectedCarrierRate === undefined || !formState.isValid;
  };

  const convertProductList = (list: MegaCarrierRate[]) => {
    const newProductList: TopupProductsProps['products'] = UtilService.convertProductList(list);
    setProductList(newProductList);
  };

  const onSelectedProduct = (id: string) => {
    const rate = carrierRates.find((r) => `${r.id}` === `${id}`);

    if (rate) {
      setSelectedCarrierRate(rate);
    }
  };

  const submitForm = (data: FieldValues) => {
    addNautaItem({
      carrier: carrier,
      carrierRate: selectedCarrierRate,
      nauta: `${data.nauta}${NAUTA_SUFFIX}`,
      type: 'other',
    } as TopUpNautaItem);

    reset();
  };

  return (
    <div>
      <form noValidate onSubmit={handleSubmit(submitForm)}>
        <div>
          <div className="megaInput mt-5">
            <label htmlFor="nauta">Nauta</label>
            <div className="input-group">
              <input
                id="nauta"
                type="text"
                className={`form-control mega ${
                  formState.errors.nauta ? 'border border-danger' : ''
                }`}
                {...register('nauta')}
                autoComplete="off"
              />
              <span className="bg-mega_gray_light input-group-text mega">{NAUTA_SUFFIX}</span>
            </div>
          </div>
          {formState.errors.nauta && (
            <div className="text-danger">{formState.errors.nauta.message}</div>
          )}
        </div>

        <Row className="mt-3">
          <Col>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col>
            {!!productList && productList.length > 0 && !!selectedCarrierRate && (
              <TopupProducts
                selectedId={selectedCarrierRate.id}
                products={productList}
                onSelectedChange={onSelectedProduct}
              />
            )}
          </Col>
        </Row>

        <Row>
          <Col></Col>
          <Col lg={6}>
            <TopUpAddButton disabled={isButtonDisabled()} isProcessing={false} isSubmit />
          </Col>
        </Row>
      </form>
    </div>
  );
};
